// extracted by mini-css-extract-plugin
export default {"header":"header__3ax1h","active":"active__2XB2z"};